(() => {
  const body = document.body;
  const toast = document.querySelector('[data-toast]');
  let toastTimer;

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 3000);
  };

  const getDrawer = () => document.querySelector('[data-cart-drawer]');

  const openDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('is-locked');
    drawer.querySelector('[data-cart-close]')?.focus();
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('is-locked');
  };

  const refreshCart = async ({ open = true } = {}) => {
    const root = window.Shopify?.routes?.root || '/';
    const [sectionResponse, cartResponse] = await Promise.all([
      fetch(`${root}?section_id=cart-drawer`),
      fetch(`${root}cart.js`)
    ]);

    if (!sectionResponse.ok || !cartResponse.ok) {
      throw new Error('Warenkorb konnte nicht geladen werden.');
    }

    const sectionHtml = await sectionResponse.text();
    const cart = await cartResponse.json();
    const parser = new DOMParser();
    const newDrawer = parser.parseFromString(sectionHtml, 'text/html').querySelector('#CartDrawer');
    const currentDrawer = document.querySelector('#CartDrawer');

    if (newDrawer && currentDrawer) currentDrawer.replaceWith(newDrawer);

    document.querySelectorAll('[data-cart-count]').forEach((bubble) => {
      bubble.textContent = cart.item_count;
      bubble.hidden = cart.item_count === 0;
    });

    if (open) openDrawer();
  };

  const activateProductMedia = (root, mediaId) => {
    if (!root || !mediaId) return;
    root.querySelectorAll('[data-product-media]').forEach((item) => {
      item.classList.toggle('is-active', item.dataset.productMedia === mediaId);
    });
    root.querySelectorAll('[data-media-target]').forEach((item) => {
      item.classList.toggle('is-active', item.dataset.mediaTarget === mediaId);
    });
  };

  const getSelectedFlavors = (root) => (
    [...root.querySelectorAll('[data-flavor-checkbox]:checked')].map((input) => input.value)
  );

  const setFlavorState = (root, packSize, reset = false) => {
    const checkboxes = [...root.querySelectorAll('[data-flavor-checkbox]')];
    const instruction = root.querySelector('[data-flavor-instruction]');
    const property = root.querySelector('[data-flavor-property]');
    const status = root.querySelector('[data-flavor-status]');
    const fixedTrio = ['litchi', 'peach', 'grape'];

    if (!checkboxes.length) return;

    checkboxes.forEach((checkbox) => {
      const isLockedSet = packSize === 3 || packSize === 5;
      const isUnavailableSingle = packSize === 1 && checkbox.dataset.available === 'false';
      checkbox.disabled = isLockedSet || isUnavailableSingle;
      checkbox.closest('.flavor-chip')?.classList.toggle('is-locked', isLockedSet);
      checkbox.closest('.flavor-chip')?.classList.toggle('is-disabled', isUnavailableSingle);
    });

    if (packSize === 5) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = true;
      });
      if (instruction) instruction.textContent = 'Alle fünf sind dabei.';
    } else if (packSize === 3) {
      checkboxes.forEach((checkbox) => {
        checkbox.checked = fixedTrio.includes(checkbox.value);
      });
      if (instruction) instruction.textContent = 'Festes Trio: litchi, peach & grape.';
    } else if (reset) {
      const firstAvailable = checkboxes.find((checkbox) => checkbox.dataset.available !== 'false');
      checkboxes.forEach((checkbox) => {
        checkbox.checked = checkbox === firstAvailable;
      });
      if (instruction) {
        instruction.textContent = 'Wähle genau einen Mood.';
      }
    } else {
      const selected = checkboxes.filter((checkbox) => checkbox.checked);
      if (selected.length > packSize) {
        selected.slice(packSize).forEach((checkbox) => {
          checkbox.checked = false;
        });
      }
      let count = checkboxes.filter((checkbox) => checkbox.checked).length;
      checkboxes.forEach((checkbox) => {
        if (count < packSize && !checkbox.checked) {
          checkbox.checked = true;
          count += 1;
        }
      });
    }

    checkboxes.forEach((checkbox) => {
      checkbox.closest('.flavor-chip')?.classList.toggle('is-selected', checkbox.checked);
    });

    const flavors = getSelectedFlavors(root);
    if (packSize === 1) {
      const selectedFlavor = checkboxes.find((checkbox) => checkbox.checked);
      const variantInput = root.querySelector('[data-variant-id]');
      if (variantInput && selectedFlavor?.dataset.variantId) {
        variantInput.value = selectedFlavor.dataset.variantId;
      }
    }
    if (property) property.value = flavors.join(', ');
    if (status) {
      status.textContent = packSize === 5
        ? 'litchi, peach, grape, watermelon und orange'
        : packSize === 3
          ? 'litchi, peach und grape · festes Trio'
          : flavors.length
            ? `${flavors[0]} ausgewählt`
            : 'Bitte einen Mood wählen';
      status.classList.remove('is-error');
    }
  };

  const selectPack = (input, resetFlavors = true) => {
    const root = input.closest('[data-product-root]');
    if (!root) return;

    root.querySelectorAll('.pack-option').forEach((option) => {
      option.classList.toggle('is-selected', option.contains(input));
    });

    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-product-price]');
    const unitPrice = root.querySelector('[data-product-unit-price]');
    const submit = root.querySelector('[data-add-to-cart]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stickyLabel = root.querySelector('[data-sticky-label]');
    const heading = root.querySelector('[data-product-heading]');
    const packSize = Number(input.dataset.packSize || 1);
    const packName = input.closest('.pack-option')?.querySelector('strong')?.textContent || 'Set';

    if (variantInput) variantInput.value = input.value;
    if (price) price.textContent = input.dataset.price;
    if (unitPrice) unitPrice.textContent = input.dataset.unitPrice;
    if (submit) submit.textContent = `In den Warenkorb — ${input.dataset.price}`;
    if (stickyPrice) stickyPrice.textContent = input.dataset.price;
    if (stickyLabel) stickyLabel.textContent = packSize === 5 ? '5er-Set vorausgewählt' : `${packName} ausgewählt`;
    if (heading && input.dataset.productTitle) heading.textContent = input.dataset.productTitle;

    setFlavorState(root, packSize, resetFlavors);
    const mediaId = packSize === 1
      ? getSelectedFlavors(root)[0] || 'litchi'
      : input.dataset.mediaId;
    activateProductMedia(root, mediaId);
  };

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const requestedVariant = new URLSearchParams(window.location.search).get('variant');
    const requestedFlavor = requestedVariant
      ? root.querySelector(`[data-flavor-checkbox][data-variant-id="${requestedVariant}"]`)
      : null;
    const requestedInput = requestedFlavor
      ? root.querySelector('[data-pack-option][data-pack-kind="single"]')
      : requestedVariant
      ? root.querySelector(`[data-pack-option][value="${requestedVariant}"]`)
      : null;
    const checkedInput = requestedInput || root.querySelector('[data-pack-option]:checked');
    if (checkedInput) {
      checkedInput.checked = true;
      selectPack(checkedInput, true);
      if (requestedFlavor && requestedFlavor.dataset.available !== 'false') {
        root.querySelectorAll('[data-flavor-checkbox]').forEach((checkbox) => {
          checkbox.checked = checkbox === requestedFlavor;
        });
        setFlavorState(root, 1, false);
        activateProductMedia(root, requestedFlavor.value);
      }
    }
  });

  document.addEventListener('click', async (event) => {
    const menuToggle = event.target.closest('[data-menu-toggle]');
    if (menuToggle) {
      const menu = document.querySelector('[data-mobile-menu]');
      const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
      menuToggle.setAttribute('aria-expanded', String(!isOpen));
      if (menu) menu.hidden = isOpen;
      return;
    }

    const mobileLink = event.target.closest('[data-mobile-menu] a');
    if (mobileLink) {
      const menu = mobileLink.closest('[data-mobile-menu]');
      const toggle = document.querySelector('[data-menu-toggle]');
      if (menu) menu.hidden = true;
      toggle?.setAttribute('aria-expanded', 'false');
    }

    const footerDisclosureLink = event.target.closest('[data-footer-disclosure-link]');
    if (footerDisclosureLink) {
      const disclosure = document.getElementById(footerDisclosureLink.dataset.footerTarget);
      if (disclosure) {
        disclosure.open = true;
        disclosure.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'center'
        });
        disclosure.querySelector('summary')?.focus({ preventScroll: true });
      }
      return;
    }

    if (event.target.closest('[data-cart-open]')) {
      openDrawer();
      return;
    }

    if (event.target.closest('[data-cart-close]')) {
      closeDrawer();
      return;
    }

    const trioQuantityButton = event.target.closest('[data-cart-trio-quantity]');
    if (trioQuantityButton) {
      const keys = String(trioQuantityButton.dataset.cartTrioKeys || '')
        .split('|')
        .map((key) => key.trim())
        .filter(Boolean);
      const quantity = Math.max(0, Number(trioQuantityButton.dataset.quantity || 0));
      const isDrawerAction = Boolean(trioQuantityButton.closest('[data-cart-drawer]'));

      if (!keys.length) {
        showToast('Das Trio konnte nicht aktualisiert werden.');
        return;
      }

      trioQuantityButton.disabled = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const updates = Object.fromEntries(keys.map((key) => [key, quantity]));
        const response = await fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Trio konnte nicht aktualisiert werden.');

        if (isDrawerAction) {
          await refreshCart();
          showToast(quantity === 0 ? 'Das ganze Trio wurde entfernt.' : 'Die Trio-Menge wurde aktualisiert.');
        } else {
          window.location.reload();
        }
      } catch (error) {
        showToast(error.message || 'Bitte versuche es noch einmal.');
        trioQuantityButton.disabled = false;
      }
      return;
    }

    const cartQuantityButton = event.target.closest('[data-cart-quantity]');
    if (cartQuantityButton) {
      cartQuantityButton.disabled = true;
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            id: cartQuantityButton.dataset.cartQuantity,
            quantity: Number(cartQuantityButton.dataset.quantity)
          })
        });
        if (!response.ok) throw new Error('Menge konnte nicht geändert werden.');
        await refreshCart();
      } catch (error) {
        showToast(error.message || 'Bitte versuche es noch einmal.');
        cartQuantityButton.disabled = false;
      }
      return;
    }

    const mediaButton = event.target.closest('[data-media-target]');
    if (mediaButton) {
      activateProductMedia(
        mediaButton.closest('[data-product-root]'),
        mediaButton.dataset.mediaTarget
      );
      return;
    }

    const stickySubmit = event.target.closest('[data-sticky-submit]');
    if (stickySubmit) {
      document.querySelector('[data-oreali-product-form] [data-add-to-cart]')?.click();
      return;
    }

    const popupClose = event.target.closest('[data-welcome-close]');
    if (popupClose) {
      const popup = popupClose.closest('[data-welcome-popup]');
      popup?.classList.remove('is-open');
      popup?.setAttribute('aria-hidden', 'true');
      try {
        window.localStorage.setItem('oreali-welcome-dismissed', '1');
      } catch (_error) {
        // Storage can be unavailable in strict privacy modes.
      }
    }
  });

  document.addEventListener('change', (event) => {
    const packInput = event.target.closest('[data-pack-option]');
    if (packInput) {
      selectPack(packInput, true);
      return;
    }

    const flavorInput = event.target.closest('[data-flavor-checkbox]');
    if (!flavorInput) return;

    const root = flavorInput.closest('[data-product-root]');
    const packInputSelected = root?.querySelector('[data-pack-option]:checked');
    const packSize = Number(packInputSelected?.dataset.packSize || 1);

    if (packSize === 1) {
      root.querySelectorAll('[data-flavor-checkbox]').forEach((checkbox) => {
        checkbox.checked = checkbox === flavorInput;
      });
      setFlavorState(root, 1, false);
      activateProductMedia(root, flavorInput.value);
      return;
    }

    setFlavorState(root, packSize, false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawer();
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();

    const root = form.closest('[data-product-root]');
    const packInput = root?.querySelector('[data-pack-option]:checked');
    const packSize = Number(packInput?.dataset.packSize || 0);
    const flavors = root ? getSelectedFlavors(root) : [];
    const status = root?.querySelector('[data-flavor-status]');

    if (packSize && flavors.length !== packSize) {
      if (status) {
        status.textContent = `Bitte genau ${packSize} ${packSize === 1 ? 'Sorte' : 'Sorten'} auswählen.`;
        status.classList.add('is-error');
      }
      showToast('Deine Sortenwahl ist noch nicht komplett.');
      return;
    }

    const button = form.querySelector('[data-add-to-cart]');
    const originalText = button?.textContent;
    if (button) {
      button.disabled = true;
      button.textContent = 'Kommt näher …';
    }

    try {
      const formData = new FormData(form);
      formData.delete('oreali-pack');
      const trioIdsRaw = packInput?.dataset.trioComponentIds
        || formData.get('oreali-trio-component-ids')
        || '';
      const trioIds = [...new Set(String(trioIdsRaw)
        .split(',')
        .map((id) => Number(id.trim()))
        .filter((id) => Number.isInteger(id) && id > 0))];
      formData.delete('oreali-trio-component-ids');

      const requestOptions = trioIds.length === 3
        ? {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: trioIds.map((id) => ({
                id,
                quantity: 1,
                properties: {
                  'Deine Sorten': 'litchi, peach, grape',
                  '_oreali_set': 'signature-trio'
                }
              }))
            })
          }
        : {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: formData
          };

      const response = await fetch('/cart/add.js', requestOptions);
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Produkt konnte nicht hinzugefügt werden.');
      await refreshCart();
      showToast('Dein Mood ist im Warenkorb.');
    } catch (error) {
      showToast(error.message || 'Bitte versuche es noch einmal.');
    } finally {
      if (button) {
        button.disabled = false;
        button.textContent = originalText;
      }
    }
  });

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const revealItems = document.querySelectorAll('.reveal');

  document.querySelectorAll('.mood-scroller, .benefit-grid, .offer-grid, .review-grid, .moment-list, .faq-list').forEach((group) => {
    [...group.children].forEach((item, index) => {
      item.style.setProperty('--reveal-delay', `${Math.min(index * 70, 280)}ms`);
    });
  });

  if ('IntersectionObserver' in window && !reducedMotion) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const popup = document.querySelector('[data-welcome-popup]');
  if (popup) {
    let dismissed = false;
    try {
      dismissed = window.localStorage.getItem('oreali-welcome-dismissed') === '1';
    } catch (_error) {
      dismissed = false;
    }

    if (!dismissed) {
      window.setTimeout(() => {
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
      }, 4500);
    }
  }
})();
